import React, { useEffect, useState } from 'react';

import PinkDotsIllustration from '../../assets/svg-components/share-dialog/select_website_dots.svg';
import DialogCloseIcon from '../../assets/svg-components/share-dialog/share_popup_close_btn.svg';
import ElementsIllustration from '../../assets/svg-components/share-dialog/share_popup_elements.svg';
import { cn } from '../../utils/classname';
import { ColorLabel } from '../color-label/color-label';
import Dialog from '../dialog/dialog';
import ShareBox from '../share-box/share-box';
import { SocialMedia } from '../social-media-buttons/social-media';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './share-dialog.scss';

type ModalProps = {
  isOpen: boolean;
  setIsDialogOpen: any;
};

const ShareDialog: React.FC<ModalProps> = ({ isOpen, setIsDialogOpen }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isClosing) {
      setTimeout(() => {
        setIsDialogOpen(false);
        setIsClosing(false);
      }, 500);
    }
  }, [isClosing, setIsDialogOpen]);

  const wrapperClasses = cn('rc-intro-section__dialog-wrapper', isClosing ? 'closing' : '');

  return (
    <Dialog
      wrapperClass={wrapperClasses}
      isOpen={isOpen}
      setIsDialogOpen={setIsDialogOpen}
      isClosing={isClosing}
      setIsClosing={setIsClosing}
    >
      <div className="rc-intro-section__dialog">
        <Title className="rc-intro-section__dialog-title" weight="bold" level="4">
          <Translate id="translate.share.dialog.title" />{' '}
          <ColorLabel backgroundColor="#98E5B9">#SiteGround23</ColorLabel>
        </Title>
        <ShareBox />
        <SocialMedia className="rc-intro-section_social-icons" />
        <DialogCloseIcon onClick={() => setIsClosing(true)} className="rc-intro-section__dialog-close-icon" />
        <PinkDotsIllustration className="rc-intro-section__dialog-pink-dots-illustration" />
        <ElementsIllustration className="rc-intro-section__dialog-pink-elements-illustration" />
      </div>
    </Dialog>
  );
};
export default ShareDialog;
